import {
	DndContext,
	DragEndEvent,
	DragOverlay,
	PointerSensor,
	TouchSensor,
	closestCenter,
	useSensor,
	useSensors,
} from '@dnd-kit/core';
import { SortableContext, rectSortingStrategy } from '@dnd-kit/sortable';
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	styled,
} from '@mui/material';
import SortableArticlesItem from './SortableArticlesItem';
import { useTranslation } from 'react-i18next';
import { SortEmoListDTO } from '@/api/DTO/information/emo.interface';

interface DndArticleListSectionProps {
	emoItems: any;
	handleRepositionItem: (activeIndex: number, overIndex: number) => void;
}

export default function DndArticleListSection({
	emoItems,
	handleRepositionItem,
}: DndArticleListSectionProps) {
	const { t } = useTranslation();

	// for input methods detection
	const sensors = useSensors(useSensor(PointerSensor), useSensor(TouchSensor));

	// triggered when dragging ends
	const handleDragEnd = (event: DragEndEvent) => {
		const { active, over } = event;
		if (!over) return;

		const activeItem = emoItems.find(
			(item: SortEmoListDTO) => item.id === active.id
		);
		const overItem = emoItems.find(
			(item: SortEmoListDTO) => item.id === over.id
		);

		if (!activeItem || !overItem) {
			return;
		}

		const activeIndex = emoItems.findIndex(
			(item: SortEmoListDTO) => item.id === active.id
		);
		const overIndex = emoItems.findIndex(
			(item: SortEmoListDTO) => item.id === over.id
		);

		if (activeIndex !== overIndex) {
			handleRepositionItem(activeIndex, overIndex);
		}
	};

	return (
		<DndContext
			sensors={sensors}
			collisionDetection={closestCenter}
			onDragEnd={handleDragEnd}
		>
			<SortableContext
				items={emoItems.map((i: { id: SortEmoListDTO }) => i.id)}
				strategy={rectSortingStrategy}
			>
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow
								sx={{
									backgroundColor: '#EEF1F6',
								}}
							>
								<StyledTableCell>{t('emo.cn_title')}</StyledTableCell>
								<StyledTableCell>{t('emo.cn_description')}</StyledTableCell>
								<StyledTableCell>{t('emo.en_title')}</StyledTableCell>
								<StyledTableCell>{t('emo.en_description')}</StyledTableCell>
								<StyledTableCell>{t('emo.type')}</StyledTableCell>
								<StyledTableCell>{t('emo.lastUpdateTime')}</StyledTableCell>
								<StyledTableCell>{t('emo.createTime')}</StyledTableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{emoItems?.map((item: SortEmoListDTO) => (
								<SortableArticlesItem key={item.id} item={item} />
							))}
						</TableBody>
					</Table>
				</TableContainer>
				<DragOverlay />
			</SortableContext>
		</DndContext>
	);
}

const StyledTableCell = styled(TableCell)({
	fontWeight: 'normal',
	minWidth: '160px',
});
